import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { fontFamily } from "../global.module.css";
import * as Style from "./style.module.css";
import * as Global from "../global.module.css";

export default function About(props) {
  return (
    <section id="about-me" className={Global.pageSection}>
      <StaticImage
        alt="profile"
        src="../../images/avatar.jpg"
        className={Style.profile}
      />
      <p className={fontFamily}>Hello, my name is Victor Cortes.</p>
      <br />
      <div className={[Style.aboutTextContainer, fontFamily].join(" ")}>
        <p>
          I am the kind of person that likes what I do, and what I like to do
          are video games and websites.
        </p>
        <p>
          I discovered the world of technology and video games when I was young,
          but once I was finishing middle school I realize that I not only like
          playing video games but also like the idea of making them.
        </p>
        <p>
          With a career chosen, I entered a high school that gave the basics in
          programming, some design, and art subjects. Because of my strong
          skills in problem-solving, programming was the correct decision to
          enter the game industry.
        </p>
        <p>
          For college in 2013, I picked the "Engineering in software
          development" degree, where I learned and improve my skills for
          software, especially for web development.
        </p>
        <p>
          Since game programming wasn't part of the curriculum a group of
          friends and I decided to graduate by project with the development of a
          game with hand-tracking in the Unity game engine.
        </p>
        <p>
          Before I graduate in 2016 I joined a small indie studio named "2DNutz"
          as a junior developer and six months later I was promoted.
        </p>
        <p>
          Two years after in 2018 I left the studio, I kept continuous learning
          about the Unity Engine, and during 2019 I attended a series of
          masterclass provided by people in the game industries as studios as
          "Amber Studio", "Gamaga", "Lienzo", "KingsIsle Entertainment" and many
          more.
        </p>
        <p>
          Since 2020 I am a freelance Fullstack web developer, but still, in my
          free time, I like to learn about Unity, Unreal Engine, and GPU
          programming with OpenGL and Vulkan.
        </p>
      </div>
    </section>
  );
}
